// extracted by mini-css-extract-plugin
export default {"footerBg":"d-z","footerTopLinks":"e-z","footerFeedback":"f-z","footerSocial":"g-z","footerLegalLinks":"h-z","footerIconCards":"i-z","footerBotCopy":"j-z"};